$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

  $('.currency-nav-change').on("click", function(e) {
      var selected_val = $(this).attr("data-value");
      var txt_symbole = $(this).attr("data-symbols");
      $('.currency-picker-js').val(selected_val).trigger('change');
      $('.nav-currency-link').text(txt_symbole);
      $(".close-menu-icon").trigger("click");
   });
    currency_active();
    function currency_active() {
      var selected = $( ".currency-picker-js option:selected" ).val();
      $( "a.currency-nav-change" ).each(function( index ) {
        var selected_val = $(this).attr("data-value");
        if(selected_val == selected) {
          $(this).addClass("active");
        }
     });
    }
  
  // Model popup always show under the logo in mobile version..
var mediaQuerySmall = 'screen and (max-width: 767px)';
enquire.register(mediaQuerySmall, {
  match: function() {
    var myVar = setInterval(myTimer, 100);
    function myTimer() {
      if($(".newsletter-modal").length > 0 ) {
       //elementOffset = $('.mobile-logo').offset().top + 80;
       var notify = '';
        elementOffset = $(".mobile-banner").height();
        if($(".notification-bar").length == 0 ) var notify = 20;
        var test = (elementOffset/2) + 60 - notify;
       $(".newsletter-modal").css("top", test);
        clearInterval(myVar);
      }
    }
     setTimeout(function(){ clearInterval(myVar); }, 20000); 
  },
  unmatch: function() {
    if($(".newsletter-modal").length > 0 ) $(".newsletter-modal").css("top", "");        
  }
});
//Logo Hide
$(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if (scroll >= 5) {
        // $(".logo").addClass("show");
        $("header").addClass("white-bg");
      	//hidden instead of removed to stop layout jumping.
      	$(".center-logo").css({'visibility':'hidden'});
      	$(".mobile-logo").fadeOut(100);

    } else {
        //$(".logo").removeClass("show");
        $("header").removeClass("white-bg");
      	$(".center-logo").css({'visibility':'visible'});
      	$(".mobile-logo").fadeIn(100);
    }


      var rv = document.querySelector('.recent-view h2');
      if (rv) {
        var x = document.querySelector('.pgv-block');
        if(x) {
        rv.classList.remove('hide');
        } else {
        rv.classList.add('hide');
        }
      }
});


// $(window).scroll(function() {
//     var scrollTop = $(window).scrollTop(),
//         divOffset = $('.help-detail').offset().top,
//         dist = (divOffset - scrollTop);
//         //$('.ml-block-toggle').text(dist);
//     if (dist <= 83) {
//       $('.mobilinks').addClass('fixed');
//       if(!$('.mobilinks-v1').length) {
//         var h = $('.mobilinks').height() + 'px';
//         $('<div class="mobilinks-v1" style="height: '+ h +'"></div>').appendTo(".help--nav");
//       }
//     } else {
//       $('.mobilinks').removeClass('fixed');
//       $('.mobilinks-v1').remove();
//     }
// });

// Buy button update on the PDP page 
setTimeout(function(){
var checkText = $('.shopify-payment-button__button').text();
  if (checkText.includes('Buy it now')){
      $('.shopify-payment-button__button').addClass('btn-custom add  large add-btn border-btn');
      $('.shopify-payment-button__button').html('BUY NOW <i class="icon icon-arrow-right"></i>');
      $(".checkout-buy-btn").removeClass('hide');

    $('.swatch-popup-size ul li').one('click', function() {
     setTimeout(function(){
      $('.shopify-payment-button__button').addClass('btn-custom add  large add-btn border-btn');
      $('.shopify-payment-button__button').html('BUY NOW <i class="icon icon-arrow-right"></i>');
      $(".checkout-buy-btn").removeClass('hide');
    },500);
    })

  }

 if ($('.template-product').length > 0) {
   $('form.form.form.product-form').attr('action', '#');
 }

},3000);


$(document).ready(function() {
  if ($('.swatch-link-size').length > 0) {
    $('.bullet-social-response .accordion').removeClass('only-shoes-dsply');
    $('.bullet-social-response .accordion-contain').removeClass('only-shoes-dsply');
  }
})


$(window).load(function() {
        var rv = document.querySelector('.recent-view h2');
      if (rv) {
        var x = document.querySelector('.pgv-block');
        if(x) {
          console.log('----------');
        rv.classList.remove('hide');
        } else {
        rv.classList.add('hide');
        console.log('++++++++++');
        }
      }
});

// header notification close button code
     if ($.cookie('notificationBar') == 'closed') {
        $('.notification-bar').remove();
        $(".site-header").removeClass("notificationShow1");
        $("body").removeClass('notify-me');
        $(".mobile-banner").removeClass('notify-mobile-banner');
      }
      else {
        $('.notification-bar').show();
        if ($('.notification-bar').length > 0) {
          $(".site-header").addClass("notificationShow1");
          $("body").addClass('notify-me');
          $(".mobile-banner").addClass('notify-mobile-banner');
        }
      }

      $('.banner-link').bind('click',function() {
        $("html, body").animate({
        scrollTop: $('.home-newsletter').offset().top
        }, 500);
      });

      $('.notification-bar a.close').bind('click',function(){
        $.cookie('notificationBar', 'closed', {expires:1});
        $('.notification-bar').remove();
        $('.site-header').removeClass('notificationShow1');
        $("body").removeClass('notify-me');
        $(".mobile-banner").removeClass('notify-mobile-banner');
       });

      if($('.notification-bar').length > 0) {
        $(window).scroll(function (event) {
        //var scroll = $(window).scrollTop();
        //var nthight = $('.notification-bar').height();
          wS = $(this).scrollTop();
         var hT1 = $('.notification-bar').offset().top;
             hH1 = $('.notification-bar').outerHeight();
        if((hH1 - wS) < 0) {
         // $('.site-header').removeClass('notificationShow1');
          $("body").removeClass('notify-me');
          //$(".mobile-banner").removeClass('notify-mobile-banner');
        }
        else {
         // $('.site-header').addClass('notificationShow1');
          $("body").addClass('notify-me');
          //$(".mobile-banner").addClass('notify-mobile-banner');
        }
        });
      }
 // header notification code end
 /*
 $('.nswtr').on("click", function(event){
    $(".home-newsletter").toggleClass('active');
 });

 // footer information dropdown code start
 $(document).on("click", function(event){
        var $trigger = $(".dropdown");
        if($trigger !== event.target && !$trigger.has(event.target).length){
            $(".dropdown-menu").slideUp("fast");
        }
    });
 // footer information dropdown code end
 */
function remove_lander(){
	$(".landing-overlay").hide();
  	//console.log('lander removed');
}
$(document).ready(function() {
  //headerClr();

    //Home banner image session storage
    if ($(".landing-overlay-hide").length  ==  0 ) {
      var chkReadyState = setInterval(function() {
          if (document.readyState == "complete") {
              // clear the interval
              clearInterval(chkReadyState);
              setTimeout(function(){
              $(".landing-overlay").animate({ height: 0, opacity: 0, }, 'slow', function() { remove_lander() });
              sessionStorage.setItem("landing-banner", "true");
              $("body").removeClass("landing-screen");
               }, 5000);
          }
        }, 100);
     }
    $(".landing-js").click(function(e) {
      $(".landing-overlay").animate({ height: 0, opacity: 0}, 'slow', function() { remove_lander() });
      sessionStorage.setItem("landing-banner", "true");
      $("body").removeClass("landing-screen");
    });

  // custom newsletter drop-down
  customDropdown();

  // fancy select on the newsletter.
  //$('.fancySelect').fancySelect();

  // Home slider section.
  $('.home-slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
     arrows:false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.home-slider-carousel').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 5,
     arrows:true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
	
// campaign new v2 page product slider section im mobile.
  $('.campaign-products-mobile').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows:false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
if($('#jwplayerBox').length) {
  // jwplayer("jwplayerBox").setup({
  //   "file": "http://content.jwplatform.com/videos/URccyw7g-GAqnNE8a.mp4",
  //   "image": "http://assets-jpcust.jwpsrv.com/thumbs/URccyw7g-1920.jpg",
  //   "height": 700,
  //   "width": 1920
  // });
}
    //Scroll to top
    $("#topScroll").click(function (e) {
      e.preventDefault();
      console.log("wow");
      $("html, body").animate({scrollTop : 0}, 600);
      return false;
    });

    // sexy select drop-down custom changes
    $(document).on('click', '.select-toggle', function(e) {
        var $openMenu = $('.select-menu a.select-toggle.open');
        if ($openMenu.length > 0 && $(this).hasClass("selected")) {
            $openMenu.removeClass('open');
        }
        $(this).toggleClass("selected");
    });
    $(document).on('click', '.select-menu ul li span.selected', function(e) {
      $(".select-toggle").removeClass("selected");
    });

    //Sexy select
    if($('.sexyselect').length) {
      var sexiesFixed = $('.sexyselect').sexySelect({
        width: '100%'
      });
    }
    // sexy select drop-down custom changes
    if($(".product-gift-card").length > 0) {
      $(document).on('click', '.select-toggle', function(e) {
          var $openMenu = $('.select-menu a.select-toggle.open');
          if ($(this).hasClass("selected-opt")) {
              $openMenu.removeClass('open');
          }
          $(this).toggleClass("selected-opt");
      });
      $(document).on('click', '.select-menu ul li span.selected', function(e) {
        $(".select-toggle").removeClass("selected-opt");
      });
    }



  // Navigation update.
  var navTriggerMethod;
  function navMenus() {
    // Removes old event listener
    $(document).off(navTriggerMethod, '[data-header-item]');

    // Finds screen width and assigns navTriggerMethod
    if($(window).width() < 768) {
      navTriggerMethod = 'click';
    } else {
      navTriggerMethod = 'mouseover';
    }

    console.log({navTriggerMethod});

    // Adds/Readds event listener
    $(document).on(navTriggerMethod, '[data-header-item]', function(e) {
      e.preventDefault();
      $(".nav-img-block").hide();
      if($("li.site-nav-active a.active").length > 0) {
        var outer = $("li.site-nav-active a.active").data('iblock');
        $("#" + outer).show();
      }
      var outer = $(this).parent().attr('class');
      $("ul li.dropdown").each(function() {
      var inner = $(this).attr('class');
        if (outer != inner) {
          $(this).find( "ul" ).removeClass('active');
          $(this).removeClass('current');
        }
      });
      $(this).next().addClass('active');
      $(this).parent().addClass('current');

      $(".page-overlay").removeClass("active");
      $("header").removeClass("menu-active");
      if($(".filter").length > 0) $(".filter").css("display", "inline-block"); 
      if($(this).next().hasClass("active")) {
        //$(".page-overlay").addClass("active");
        $("header").addClass("menu-active");
        // if($(".filter").length > 0) $(".filter").css("display", "none");
      }
      
      if($(".js-filter-block.active").length > 0) {
        $(".js-filter-block").removeClass("active");
        $(".result a.filter").removeClass('active');
        $("#shop_Collection").css("margin", "");
      }
    });
  }

  navMenus();

  // Updates 
  var resizeTimer;
  $(window).on('resize', function(e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if($(window).width() < 768 && navTriggerMethod != 'click') {
        navMenus();
      } else if($(window).width() > 767 && navTriggerMethod != 'mouseover') {
        navMenus();
      }
    }, 250);
  });


  $(document).on('mouseover', '.submenu li a', function(e) {
    var outer = $(this).data('iblock');
    $(".nav-img-block").hide();
    $("#" + outer).show();
  });


/*  $(document).on('click', '.page-overlay.active', function(e) {
      $(".page-overlay").removeClass("active");
      $("ul li.dropdown").find( "ul" ).removeClass('active');
      $("ul li.dropdown").removeClass('current');
  });*/

  // $(document).on('click', '[data-submenu-back]', function(e) {
  //     $(".page-overlay").removeClass("active");
  //     $("header").removeClass("menu-active");
  //     $("ul li.dropdown").find( "ul" ).removeClass('active');
  //     $("ul li.dropdown").removeClass('current');
  //     $("a.dropbtn.nav-links").removeClass('active');
  // });

  $(document).on('click', ".mobile-nav-toogle", function() {
    $("a.dropbtn.nav-links").removeClass('active');
  });

  $(document).on('mouseleave', 'header.site-header', function() {
    $("ul li.dropdown").find( "ul" ).removeClass('active');
    $("ul li.dropdown").removeClass('current');
    $("a.dropbtn.nav-links").removeClass('active');
  })

  $(document).on('click', '.close-menu-icon,.page-overlay, [data-submenu-back], .mobile-nav-toogle.active', function(e) {
    $(".page-overlay").removeClass("active");
    $("header").removeClass("menu-active");
    $("ul li.dropdown").find( "ul" ).removeClass('active');
    $("ul li.dropdown").removeClass('current');
    $("a.dropbtn.nav-links").removeClass('active');
  });
/*  $(window).scroll(function() {
    if($('.page-overlay.active').length > 0 ) {
      $(".page-overlay").removeClass("active");
      $("ul li.dropdown").find( "ul" ).removeClass('active');
      $("ul li.dropdown").removeClass('current');
      }
  });*/

/*  $(document).on("click", function(event){
    var $trigger = $(".dropdown");
    if($trigger !== event.target && !$trigger.has(event.target).length){
        document.querySelector('.dropbtn ~ .submenu').classList.remove('active');
    document.querySelector('.dropbtn ~ .submenu').parentNode.classList.remove('current');
    }
  });*/


  // if($('.currency-picker').length) {
  //   var sexiesFixed = $('.currency-picker').sexySelect({
  //     width: '100%'
  //   });
  // }

   var htmlString = $('.doubly-float' ).text();

 $('#info_mobile').on("click", function(event){
    document.querySelector('.mobile-nav .main-nav').classList.toggle('hide');
    document.querySelector('.mobile-nav .dropdown-menu').classList.toggle('hide');

    // if($(".dropdown-menu").hasClass('hide')) {
    //       $('.dropdown-menu').removeClass('hide');
    //     }
    //     else {
    //       $('.dropdown-menu').addClass('hide');
    //     }
 });
 $('.info.menuicon').on("click", function(event){
  document.querySelector('.foot-nav .dropdown-menu').classList.toggle('hide');
 });

if($('.product-description').text().length >= 150){
  // add more link in after  product description
  $( '<a class="readmore border" href="#">More</a>' ).insertAfter( ".product-description" );
}



/* $(".dropdown").hover(function(){
    $(this).find(".dropdown-menu").show();
 });*/

	//$('#list_view_layout').hide();
  // var cartJSON = JSON.parse(document.getElementById('cartJSON').innerHTML)
  //   CartJS.init(cartJSON, {
  //     'debug': false,
  //     'dataAPI': true,
  //     'requestBodyClass': 'cart-loading',
  //     'moneyFormat': theme.moneyFormat,
  //     'moneyWithCurrencyFormat': ''
  //   });
  //   console.log(theme.moneyFormat);

  //   $(document).on('cart.requestStarted', function() {
  //     console.log('CartJS.settings.requestBodyClass');
  //     //return jQuery('body').addClass(CartJS.settings.requestBodyClass);
  //   });

  //   $(document).on('cart.requestComplete', function(event, cart) {
  //     if(cart.item_count == 0) {
  //       $('#cart-bar-model').removeClass('cart-active');
  //       $('.item-count').html('');
  //     }
  //     else {
  //       $('.item-count').html(cart.item_count);
  //       $('#cart-bar-model').addClass('cart-active');
  //     }
  //   });



	$(".gbp-toogle").click(function(){
        $(".currency").toggleClass("active");
    });

  $(document).keyup(function(e) {
     if (e.keyCode == 27 ) {
      if ($('.search-popup').length) {
        $(".search-popup").removeClass('active');
      }
    }
  });

 	$(".foot-search, .close-search, .mobile-search").click(function(){
        $(".search-popup").toggleClass("active");
        setInterval("$('.auto-focus').show().focus();", 500);
        //jQuery(".search-popup .auto-focus").show().focus();
        //console.log("ddddd");
    });
	 $(".forgot").click(function(){
        $(".reset-password").removeClass("hide");
        $("#form1").hide();
    });

    $(".login-link, .nswtr").click(function(){
        $(".login-popup").toggleClass("active");
    });

    $(".open-signup-popup").click(function(e){
      e.preventDefault();
      NEOUS.widget.popup('direct');
    });

    $(".login-popup #close-login-popup").click(function(){
     $(".login-popup").toggleClass("active");
    })

	  $(".cart").hover(function(){
        $(".cart-item").toggleClass("active");
    });
	// $(".cart").click(function(){
 //    $(".cart-popup").addClass('active');
	// 	$('.recently-added').show();
 //    });

	$(".add").click(function(){
//  		$(".cart-popup").addClass('active');
      
            setTimeout(function() {
                $(".cart-popup").addClass('active');
            }, 800)
        
    		$('.recently-added').show();
	});



	$(".size-care, #size-care-close").click(function(){
	    $(".size-care-popup").toggleClass('active');
	});

	$(".size-unavailable, #size-unavailable-close").click(function(){
	    $(".size-unavailable-popup").toggleClass('active');
	});

  $(".shipping-returns, #shipping-returns-close").click(function(){
      $(".shipping-returns-popup").toggleClass('active');
  });

  $(".js-click-swatch, #swatch-close").click(function(){
    $(".swatch-popup").toggleClass('active');
  });

  $(".swatch-color-opt .swatch-element img").click(function () {
    $(".swatch-popup").toggleClass('active');
  })


  $(".js-click-size, #swatch-size-close").click(function(){
    $(".swatch-popup-size").toggleClass('active');
  });


  var dataVariant = $('.swatch-popup-size input[name="option-0"]:checked').data("variant");
  $(".swatch-link-size span").text(dataVariant);

  $(".swatch-popup-size li div input").click(function () {
    var dataVariant = $(this).data("variant");
    $(".swatch-link-size span").text(dataVariant);
    $(".swatch-popup-size").toggleClass('active');
  } )


  document.querySelectorAll('.accordion').forEach((event) => {
    event.addEventListener('click', function(e) {
       var cls =  this.classList;
       this.classList.toggle('active');
       this.nextElementSibling.classList.toggle('active');
       document.querySelectorAll('.accordion').forEach((ev) => {
          if(ev.classList != cls) {
             ev.classList.remove("active");
             ev.nextElementSibling.classList.remove('active');              
          }
       });
    });
  });



	// $("#layout_expended").click(function(){
	// 	$("#layout_expended").addClass('active');
	// 	$("#layout_grid").removeClass('active');
 //  });
  
	$("#layout_grid").click(function(){
		$("#layout_grid").addClass('active');
		$("#layout_expended").removeClass('active');
  });

	/* for content less & more function */
	 $('.readmore').click(function (event) {
        event.preventDefault();
        var description = document.querySelector('.product-description');
        //console.log(description.style.height)
        if (description.style.height === ''){
          description.style.height = 'auto';
        } else if (description.style.height === 'auto'){
          description.style.height = '';
        }
        else{
          description.style.height = '92px';
        }
        $(this).text($(this).text() == 'Less' ? 'More' : 'Less');
    });

	  // color swatch
      if ($('.swatch :radio').length) {
        $('.swatch :radio').change(function() {
          var optionIndex = $(this).closest('.swatch').attr('data-option-index');
          var optionValue = $(this).val();
          $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
        });
      }
});

//loginregisterform
 function register(i)
  {
    document.getElementById("form"+i).style.display = 'none';
    i++;
    document.getElementById("form"+i).style.display = 'block';
  }


//scrolltofixed
$(document).ready(function() {
  
   $(document).on('click', '.mobile-nav-toogle', function(e){
      e.preventDefault();
      $("body").toggleClass("overlay");
      $(".mobile-nav-toogle, .mobile-nav").toggleClass("active");
      $(".site-header").toggleClass("mobile-nav-open");
      if($('body').hasClass('template-index') && $(window).width() < 768){
        if ($(".mobile-nav").hasClass('active')) {
          $(".site-header").removeClass("home-mobile-header");
        } else {
          $('.site-header').addClass('home-mobile-header');
        }
      }
    });

    var sh = $('.site-header').outerHeight();
    $('.site-header').scrollToFixed();
/*    if($('body').hasClass('template-index') && $(window).width() < 768){
      $('.mobile-banner').css('top', sh);
      $('.main-content').css('margin-top', -sh);
    } else{
      $('.mobile-banner').removeAttr('style');
      $('.main-content').removeAttr('style');
    }*/
});

// custom js code
$('.password-match').hide();
$('form#create_customer').submit(function(e) {
if ( $('#CreatePassword').val() != $('#customer_password_confirmation').val()) {
  e.preventDefault(); // stops our form from submitting
  $('.errors').hide();
  $('.password-match').fadeIn("slow");

}
});

$('form#customer_login input').blur(function()
{
    if( !$(this).val() ) {
      $(this).addClass('input--error');
    }
});

$(document).ready(function() {
    setTimeout(function() {
      /*var preorderText = $('#cart').data('preorder');
      var deliveryPreorderText = $('#cart').data('deliverytext');*/
      var preorderText = $('.preorder-propeerties-value').val();
      var deliveryPreorderText = $('.ddm-propeerties-value').val();
      //$('.preorder-text').text(preorderText);
      //$('.delivery-preorder-text').text(deliveryPreorderText);

    $('.preorder-hide').removeClass('load-hide');  

    $('.preorder-hide li .property-name span').each(function(index, element) {
      var clsProperty = $(element).text();
      $(element).parent().addClass(clsProperty);
      $(element).parent().parent().addClass('line-item-' + clsProperty);
    })
  }, 600)
});

/* custom select dropdown start */
function customDropdown() {
  if($(".custom-select").length) {
    var x, i, j, selElmnt, a, b, c;
    //var cars = ["custom-select-age", "custom-select-size", "custom-select-country"];
    /*look for any elements with the class "custom-select":*/
    x = document.getElementsByClassName("custom-select");
    for (i = 0; i < x.length; i++) {
      selElmnt = x[i].getElementsByTagName("select")[0];
      /*for each element, create a new DIV that will act as the selected item:*/
      a = document.createElement("DIV");
      a.setAttribute("class", "select-selected");
      a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
      x[i].appendChild(a);
      /*for each element, create a new DIV that will contain the option list:*/
      b = document.createElement("DIV");
      b.setAttribute("class", "select-items select-hide");
      for (j = 1; j < selElmnt.length; j++) {
        /*for each option in the original select element,
        create a new DIV that will act as an option item:*/
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;
        c.addEventListener("click", function(e) {
            /*when an item is clicked, update the original select box,
            and the selected item:*/
            var y, i, k, s, h;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            h = this.parentNode.previousSibling;
            for (i = 0; i < s.length; i++) {
              if (s.options[i].innerHTML == this.innerHTML) {
                s.selectedIndex = i;
                //if($(".custom-select").attr("id")!="custom-select-sortby"){
                  h.innerHTML = this.innerHTML;
               // }
                y = this.parentNode.getElementsByClassName("same-as-selected");
                for (k = 0; k < y.length; k++) {
                  y[k].removeAttribute("class");
                }
                this.setAttribute("class", "same-as-selected");
                break;
              }
            }
            h.click();
        });
        b.appendChild(c);
      }
      x[i].appendChild(b);
      a.addEventListener("click", function(e) {
          /*when the select box is clicked, close any other select boxes,
          and open/close the current select box:*/
          e.stopPropagation();
          closeAllSelect(this);
          this.nextSibling.classList.toggle("select-hide");
          this.classList.toggle("select-arrow-active");
        });
    }
    function closeAllSelect(elmnt) {
      /*a function that will close all select boxes in the document,
      except the current select box:*/
      var x, y, i, arrNo = [];
      x = document.getElementsByClassName("select-items");
      y = document.getElementsByClassName("select-selected");
      for (i = 0; i < y.length; i++) {
        if (elmnt == y[i]) {
          arrNo.push(i)
        } else {
          y[i].classList.remove("select-arrow-active");
        }
      }
      for (i = 0; i < x.length; i++) {
        if (arrNo.indexOf(i)) {
          x[i].classList.add("select-hide");
        }
      }
    }

    var ele = document.querySelectorAll('.newsletter-modal .select-selected');

      for(i=0; i<ele.length; i++){
      ele[i].addEventListener("click", function(e) {
                /*when the select box is clicked, close any other select boxes,
                and open/close the current select box:*/
                e.stopPropagation();
               // closeAllSelect(this);
                this.nextSibling.classList.toggle("select-hide");
                this.classList.toggle("select-arrow-active");
              });
      }
  }
}

var NEOUS = NEOUS || {};
(function($) {

  // USE STRICT
  "use strict";
  var addToCart, addToCartFail, addToCartPass, cart_dropdown_timer, current_window, fadeOutCartDropdown, log;
  var curURL, shopCurrency, defaultCurrency, cookieCurrency;
  var cache = {},
  classes = {};
  log = function(value) {
    if (typeof console !== "undefined") {
      return console.log(value);
    }
  };

  NEOUS.cart = {
    init: function() {
      NEOUS.cart.requestReturn();
      //NEOUS.cart.submitForm();
      $('.minicart-block').click(function(event){
        if (!$(event.target).hasClass("button-link")) {
          event.stopPropagation();
        }
      });
      // Hide mini cart popup on body click
      $(document).on('click', 'body.hide-min-popup', function(event) {
        if (!$(event.target).hasClass("button-link")) {
          $("body").removeClass("hide-min-popup");
          NEOUS.cart.slideOutCart();
        }
      });

      $cartItem.on('mouseenter', function(e) {
        e.preventDefault();
        return NEOUS.cart.customScroll();
        //return NEOUS.cart.slideInCart();
      });
      $miniCartBlock.on('mouseleave', function() {
        //return NEOUS.cart.slideOutCart();
      });
      $('.minicart-popup-cancel').on('click', function(e) {
         $body.removeClass("hide-min-popup");
		 $(".cart-popup").removeClass('active');
         e.preventDefault();
        return NEOUS.cart.slideOutCart();
      });
      
      $('.close-popup-overlay').on('click', function(e) {
         $body.removeClass("hide-min-popup");
		 $(".cart-popup").removeClass('active');
         e.preventDefault();
        return NEOUS.cart.slideOutCart();
      });
    },
    requestReturn: function() {
      var rrl = '.request-return-module',
      el = document.querySelector(rrl),
      rb = document.querySelector('.return-block');
      if (el) {
        //needs to be passed to the snippet
        var order_date_string = el.getAttribute('data-orderdate'),
        //(should be 14 days) We could wire this up to theme settings
        //number_of_days_for_an_exchange = el.getAttribute('data-maxreturn');
        number_of_days_for_an_exchange = 62;

        var order_date = new Date(Date.parse(order_date_string));
        var now_date = new Date();
        var time_diff = Math.abs(now_date.getTime() - order_date.getTime());
        var diff_days = Math.ceil(time_diff / (1000 * 3600 * 24));

        //exchanges only allowed within 14 days.
        if(diff_days < number_of_days_for_an_exchange){
          el.classList.remove('hide');
        } else {
          document.querySelector('.return-expired').classList.remove('hide');
        }

        el.addEventListener('click', function (event) {
          event.preventDefault();
          rb && rb.classList.toggle('hide');
        });

      }
    },
    submitForm: function(){
      if( $cartForm.length > 0 ) {
        $cartForm.submit(function() {
          NEOUS.cart.addToCart($(this));
          return false;
        });
      }
    },

    toggleCartDropdown: function() {
      return $recentlyAdded.slideToggle('fast');
    },
    slideDownCartDropdown: function() {
      $recentlyAdded.slideDown('fast');
      return $("html, body").animate({
        scrollTop: 0
      });
    },
    openMobileModal: function() {
      return $recentlyAdded.removeClass('hide').fadeIn();
    },
    fadeInCartDropdown: function() {
      clearTimeout(cart_dropdown_timer);
      return NEOUS.cart.cartItemPopUp();
    },
    fadeOutCartDropdown: function() {
      clearTimeout(cart_dropdown_timer);
     // $body.removeClass('body-fade2');
      return $recentlyAdded.fadeOut('fast').addClass('hide');
    },
    slideInCart: function(){
      clearTimeout(cart_dropdown_timer);
      return NEOUS.cart.cartItemPopUp();

    },
    slideOutCart: function(){
      // $miniCartBlock.css({'display': 'none'});
      return true;
    },
    startTimer: function() {
      NEOUS.cart.customScroll();
      return cart_dropdown_timer = setTimeout((function() {
        //return NEOUS.cart.slideOutCart();
      }), 4000);
    },
    stopResetTimer: function() {
      return clearTimeout(cart_dropdown_timer);
    },
    validateSize: function(cart_form) {
      if (cart_form.find('select option:selected').is(':disabled')) {
        cart_form.find('.dropdown').effect('shake', {
          'times': 2,
          'distance': 5
        }, 400);
        return false;
      }
      return true;
    },
    addToCart: function(cart_form) {
      return $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: cart_form.serialize(),
        success: NEOUS.cart.addToCartPass,
        error: NEOUS.cart.addToCartFail
      });
    },
    removeFromCart: function(e) {
      var lineItem = e + 1;
      return $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        async: false,
        data: "quantity=0&line=" + lineItem,
        success: function(e) {
          var row = lineItem -1;
          clearTimeout(cart_dropdown_timer);
          $('.cart-row-' + row).remove();
          NEOUS.cart.cartItemPopUp();
        },
        error: NEOUS.cart.addToCartFail
      });
    },
    removeFromCartPass: function(e) {
      clearTimeout(cart_dropdown_timer);
      $('.cart-row-' + e).remove();
      NEOUS.cart.cartItemPopUp();
    },
    addToCartPass: function(product) {
       //window.location.href = product.url;
     // console.log(product);
      
      
   
      
      //return NEOUS.cart.cartItemPopUp();
      console.log("DEBUG - removed : cartItemPopUp");
      return true;
    },
    addToCartFail: function(obj, status) {
      $('.recently-added .error').text(obj.responseJSON.description);
      $('.recently-added .error').show();
      $('.recently-added table').hide();
      $('.recently-added div.row').hide();
      //NEOUS.cart.slideDownCartDropdown();
      return false;
      //return NEOUS.cart.startTimer();
    },
    customScroll: function(){
      if($(window).width() > 768) {
        $('body').addClass("hide-min-popup");
        // $miniCartBlock.css({'display': 'block'});
        var reletd = $("div.header-right-section").data().value;
        //NEOUS.widget.relatedProductCheck(CartJS.cart, reletd);
      }
      else {
        window.top.location.href = '/cart'
      }
    }
  };

  NEOUS.documentOnReady = {
    init: function(){
      NEOUS.cart.init();
    }
  };
    var $window = $(window),
    $body = $('body'),
    DOC = $(document),
	   $window = $(window),
    $cartForm = $('.cart-form'),
    $cartCount = $('.cart-count'),
    $cartItem = $('.cart-item'),
    $miniCartBlock = $('.minicart-block'),
    $miniCartPopupCancel = $('.minicart-popup-cancel');
	$(document).ready( NEOUS.documentOnReady.init );
   // $window.load( NEOUS.documentOnLoad.init );
   // $window.on( 'scroll', NEOUS.documentOnScroll.init );
})(jQuery);
